import { InjectionToken } from '@angular/core';
import { ActivitiesConfig } from './dto/activities-config';

export const API_SERVER = new InjectionToken<string>(
  'Web API Server URL with trailing forward slash'
);
export const SUBSCRIPTIONS_PAGE = new InjectionToken<string>(
  'Subscription page relative URL'
);
export const AUTH_REDIRECT_PAGE = new InjectionToken<string>(
  'Authentication redirection relative URL'
);
export const ACTIVITIES_CONFIG = new InjectionToken<ActivitiesConfig>(
  'Activities Configuration'
);

export const AVAILABLE_LOCALES = new InjectionToken<string[]>(
    'Available locales'
  );
  
  export const AVAILABLE_CURRENCIES = new InjectionToken<string[]>(
    'Available currencies'
  );
  
  export const BLUESNAP_SERVER = new InjectionToken<string>(
    'Bluesnap Server URL'
  );
  